import React, { useEffect, useMemo, useState } from "react"
import classNames from "classnames"
import heart from "../../../assets/images/pt-heart-icon.svg"
import zakatEligibleImg from "../../../assets/images/zakat-yes.svg"
import zakatNotEligibleImg from "../../../assets/images/zakat-no.svg"
import PaymentModal from "../../modals/PaymentModal"
import { Link } from "gatsby"

const DonationBox = ({ target, raised, raisedOnline, raisedOffline, currentAppeal, formID, zakatEligible, barometerText=null }) => {
  const [parentUrl, setParentUrl] = React.useState(false)
  const totalRaised = raised + raisedOnline + raisedOffline
  const isTargetReached = totalRaised >= target
  const percentage = (totalRaised / target) * 100
  const numberFormat = useMemo(() => new Intl.NumberFormat(), [])

  useEffect(() => {
    const pathNameArray = window.location.pathname.split('/')
    const parentUrl = pathNameArray[0] + "/" + pathNameArray[1] + "/" + pathNameArray[2] + "/"
    setParentUrl(parentUrl)
  }, [parentUrl])

  const [modalOpen, setModalOpen] = useState(false);
  return (
    <div
      className={classNames("work-donation", {
        "target-reached": isTargetReached,
      })}
    >
      <div>
        {isTargetReached ? (
          <header>
            <p>
              <strong>This Appeal target has been reached</strong>
            </p>
          </header>
        ) : (
          <header>
            <p>Current Appeal:</p>
            <p>
              <strong>{currentAppeal}</strong>
            </p>
          </header>
        )}
        <h3 className="title-target">Target: £{numberFormat.format(target)} </h3>
        <h3 className="title-raised">Raised: £{numberFormat.format(totalRaised)} </h3>

        <div className="donation-bar">
          <div style={{ height: `${percentage}%` }}></div>
        </div>

        {isTargetReached ? (
          <footer>
            <p>
              If you would like to contribute,
              <Link to={parentUrl}><span>please choose another project</span></Link>
            </p>
            <img src={heart} alt="heart-icon" className="heart-icon" />
          </footer>
        ) : (
          <footer >
            <p className="donation-guide">If you would like to</p><p style={{marginTop:0}} className="donation-guide">donate by Credit Card:</p>
            
            {modalOpen && <PaymentModal status={true} formId={formID} />}
            <button onClick={() => { setModalOpen(true) }} className="btn btn-primary btn-icon">
              contribute
              <img src={heart} alt="heart-icon" />
            </button>
            {zakatEligible ? <p><img src={zakatEligibleImg} alt="Zakat Eligible" /></p> : <p><img src={zakatNotEligibleImg} alt="Zakat Not Eligible" /></p>}
          </footer>
        )}

        <div className="announcement">
          <p>{barometerText ? barometerText : "In the event of more donations than the cost of this project, the surplus funds will be put towards other similar programmes"}</p>
        </div>

      </div>
    </div>
  )
}

export default DonationBox
